import { ModelType } from "~/enums/modelType";
import { IDefaultVOption } from "~/interfaces/vSelectInterfaces";
import VisualizationBuilderModel from "~/models/tracked/visualizationBuilderModel";
import VisualizationSourceDataPoint from "~/models/visualizations/visualizationSourceDataPoint";
import Guid from "../../helpers/guid";

export default abstract class VisualizationSource extends VisualizationBuilderModel {
  abstract readonly friendly_type: ModelType = null;
  source_obj_as_json_for_builder: any;
  _customRowCol: VisualizationSourceDataPoint = null;

  constructor() {
    super();
    this.defineProperty('client_id', Guid.create());
  }

  get titleOrDefault(): string {
    return this.source.titleOrDefault;
  }

  // omit this for a bad time
  get isCollectionRoot(): boolean {
    return true;
  }

  // remove this override if ._nameInParent takes off
  get rootName(): string {
    return this._nameInParent;
  }

  abstract get source();

  get object(): any {
    return this.source.object
  }

  get isPublished(): boolean {
    return this.source.isPublished
  }

  get value(): IDefaultVOption {
    return this.source.value
  }

  get type() {
    return this.friendly_type
  }

  is(...types): boolean {
    return types.includes(this.type);
  }

  // built-in and indexed picklist, dropdown, checkbox, radio & datetime fields/properties
  abstract get dimensions();

  // built-in and indexed numeric fields/properties
  abstract get measures();

  abstract get allMeasuresAndDimensions(): VisualizationSourceDataPoint[];
  abstract get builtinDimensions(): VisualizationSourceDataPoint[];
  abstract get builtinMeasures(): VisualizationSourceDataPoint[];

  get allMeasuresDimensionsBuiltins(): VisualizationSourceDataPoint[] {
    return this.allMeasuresAndDimensions.concat(this.builtinDimensions).concat(this.builtinMeasures);
  }

  get customRowCol(): VisualizationSourceDataPoint {
    if (this._customRowCol) {
      return this._customRowCol;
    }

    this._customRowCol = new VisualizationSourceDataPoint({title: "Custom Column/Row", referenced_client_id: 'static_custom_col_row', data_point_type: 0, source: this.source}, this.parent);
    return this._customRowCol;
  }

  abstract getIndexedElement(clientId: string);
}
